module.exports = __webpack_public_path__ + "whitetowel.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitetowel.png
// module id = 906
// module chunks = 0